// Verbindungs-Zustand pro Host-Interface (Tabelle link_state) für die
// Status-Seite + Topologie-Schicht "Verbindungen".
//
// Quelle ist GET /v2-api/link-state (read-only). Seit 02.11.2026 ohne eigenen
// Abruf und Takt: jede Schnittstelle ist eine Instanz link.<id>.stand über das
// Homelab-Protokoll (docs/protokoll.md › „Netzwerk über das Protokoll“) im
// gemeinsamen Netz-Stand (netz.svelte.ts); REST nur beim Start und nach
// Aktionen (refreshLinkState). Das Backend gleicht die Tabelle bei jedem
// link-Ereignis ab -- der Browser horcht nicht mehr auf den WS-Kanal "events".
// Erstes Paint sofort aus der Ablage dieses Stands.

import { linkSumme } from "./netz-protokoll";
import { getNetzLinks, refreshNetz, startNetz } from "./netz.svelte";

export interface LinkState {
  entity: string;
  host_id: string;
  iface: string;
  state: string;
  health: string; // up | degraded | down | unknown
  since: string;
  down_since?: string;
  outage: boolean;
  flaps: number;
  last_flap?: string;
  last_event?: string;
}

let _off: (() => void) | undefined;

export function startLinkState(): void {
  if (_off) return;
  _off = startNetz();
}

export function stopLinkState(): void {
  _off?.();
  _off = undefined;
}

export function getLinkStates(): LinkState[] {
  return getNetzLinks() ?? [];
}

/** Holt die Verbindungen sofort per REST -- nach einer Aktion, deren Ergebnis
 *  die Seite gleich zeigen soll (das Protokoll braucht einen Moment). */
export function refreshLinkState(): Promise<void> {
  return refreshNetz(["link"]);
}

export interface LinkStateSummary {
  total: number;
  up: number;
  degraded: number;
  outages: number; // eskalierte, offene Ausfaelle
  flaps: number; // Summe aller kurzen Flaps (lifetime)
}

let _letzte: LinkStateSummary | undefined;

// getLinkStateSummary aggregiert für Karten/Badges; dasselbe Objekt, solange
// sich keine Zahl ändert.
const _summary = $derived.by((): LinkStateSummary => {
  const s = linkSumme(getLinkStates());
  const l = _letzte;
  if (l && l.total === s.total && l.up === s.up && l.degraded === s.degraded && l.outages === s.outages && l.flaps === s.flaps) return l;
  _letzte = s;
  return s;
});

export function getLinkStateSummary(): LinkStateSummary {
  return _summary;
}
